import { render, staticRenderFns } from "./VehicleRequestBrandYearAvgPrice.vue?vue&type=template&id=58ffdc2c&"
import script from "./VehicleRequestBrandYearAvgPrice.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestBrandYearAvgPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports